import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { QueryKey } from 'common/enums/query-key';
import { BackendError } from 'common/types/errors/backendError';
import { captureMethod } from 'services/api/payment-api.service';

export function useCapturePaymentMethod(options?: UseMutationOptions<void, AxiosError<BackendError>, string, unknown>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: captureMethod,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.Offers] });
    },
    ...options,
  });
}
